import { Injectable, inject, signal, computed } from '@angular/core';
import { finalize } from 'rxjs';

import { LoadingService, OVERLAY_POSITION } from 'src/app/shared/services/loading.service';
import { NewsItem } from '../models/news.model';
import { NewsService } from '../services/news.service';

@Injectable({ providedIn: 'root' })
export class NewsStore {
  private readonly newsService = inject(NewsService);
  private readonly loadingService = inject(LoadingService);

  readonly items = signal<NewsItem[]>([]);
  readonly error = signal<string | null>(null);

  readonly top = computed(() => this.items()[0] ?? null);
  readonly list = computed(() => this.items().slice(1));

  load() {
    this.error.set(null);
    this.loadingService.show(OVERLAY_POSITION.COMPONENT);

    this.newsService
      .fetchNews()
      .pipe(finalize(() => {
        this.loadingService.hide(OVERLAY_POSITION.COMPONENT);
      }))
      .subscribe({
        next: (items) => {
          this.items.set(items ?? [])      
        },
        error: (err) => {
           this.loadingService.hide(OVERLAY_POSITION.COMPONENT);
          this.error.set('News konnten nicht geladen werden.')
          throw err;
          },
      });
  }
}
